import { FolderableType } from 'apps/folders/static/enums/folderable-type.enum';
import { ItemSelectionService } from 'ycharts/static/ts/services/item-selection.service';
import { ContentItemBase } from 'apps/folders/static/directives/content-item-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "ycharts/static/ts/services/item-selection.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i4 from "../../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i6 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i7 from "FoldersApp/features/folders-shared/folder-base/folder-base.component";
import * as i8 from "../../../../../../../../../sharing/static/sharing/ts/pipes/get-owner-display-name.pipe";
const _c0 = () => ["popover"];
const _c1 = a0 => ({ "text-blue": a0 });
function RiskProfilesSelectSavedListItemComponent_Conditional_0_ng_template_2_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "div", 6);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵelement(4, "div", 6);
    i0.ɵɵpipe(5, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(6, RiskProfilesSelectSavedListItemComponent_Conditional_0_ng_template_2_Conditional_6_Template, 1, 0, "div", 8);
} if (rf & 2) {
    const folder_r1 = ctx.folder;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(2, 3, ctx_r1.riskProfile.user_modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(5, 6, folder_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.isMultiSelect ? 6 : -1);
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-risk-profiles-select-saved-list-item", 9);
} if (rf & 2) {
    const folderable_r3 = ctx.folderable;
    const ancestorInfo_r4 = ctx.ancestorInfo;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("folderable", folderable_r3)("ancestorInfo", ancestorInfo_r4)("isMultiSelect", ctx_r1.isMultiSelect)("maxItems", ctx_r1.maxItems);
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_0_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "span");
    i0.ɵɵtext(2, "There are no risk profiles in this folder.");
    i0.ɵɵelementEnd()();
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-base", 4, 0);
    i0.ɵɵtemplate(2, RiskProfilesSelectSavedListItemComponent_Conditional_0_ng_template_2_Template, 7, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, RiskProfilesSelectSavedListItemComponent_Conditional_0_ng_template_4_Template, 1, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, RiskProfilesSelectSavedListItemComponent_Conditional_0_ng_template_6_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderColumnDataFragment_r5 = i0.ɵɵreference(3);
    const listItemFragment_r6 = i0.ɵɵreference(5);
    const emptyFolderFragment_r7 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", ctx_r1.folderable)("ancestorInfo", ctx_r1.ancestorInfo)("folderColumnDataFragment", folderColumnDataFragment_r5)("listItemFragment", listItemFragment_r6)("emptyFolderFragment", emptyFolderFragment_r7);
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 22);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("textContent", ctx_r1.riskProfile.name);
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 23);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("textContent", ctx_r1.riskProfile.name);
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tooltipTitle", ctx_r1.riskProfile.description)("tooltipHtml", true)("tooltipClasses", i0.ɵɵpureFunction0(5, _c0))("tooltipPlacement", "left");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_20_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 29);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-remove-circle");
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_20_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 30);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, ctx_r1.isSelectionEnabled))("name", "icon-add-circle");
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_20_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵlistener("click", function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_20_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.itemSelectionService.toggleSelectedItem(ctx_r1.riskProfile)); });
    i0.ɵɵelementStart(1, "div", 27)(2, "button", 28);
    i0.ɵɵconditionalCreate(3, RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_20_Conditional_3_Template, 1, 1, ":svg:svg", 29)(4, RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_20_Conditional_4_Template, 1, 4, ":svg:svg", 30);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", !ctx_r1.isSelected && !ctx_r1.isSelectionEnabled);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.isSelected ? 3 : 4);
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "label", 14)(3, "input", 15);
    i0.ɵɵlistener("click", function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.bulkActionSelectionService.toggleSelectedItem(ctx_r1.folderable.resourceType, ctx_r1.riskProfile.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵlistener("click", function RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.itemSelectionService.toggleSelectedItem(ctx_r1.riskProfile)); });
    i0.ɵɵelementStart(6, "div", 18)(7, "div", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 20);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 21);
    i0.ɵɵtext(10, "rp");
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(11, RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_11_Template, 1, 1, "span", 22)(12, RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_12_Template, 1, 1, "a", 23);
    i0.ɵɵconditionalCreate(13, RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_13_Template, 2, 6, "div", 24);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 5);
    i0.ɵɵelement(15, "div", 6);
    i0.ɵɵpipe(16, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 7);
    i0.ɵɵelement(18, "div", 6);
    i0.ɵɵpipe(19, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(20, RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Conditional_20_Template, 5, 2, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("bg-yc-blue-90", ctx_r1.isBulkSelected && ctx_r1.isBulkActionMode || ctx_r1.isSelected && !ctx_r1.isBulkActionMode);
    i0.ɵɵproperty("folderable", ctx_r1.folderable)("ancestorInfo", ctx_r1.ancestorInfo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.isBulkSelectionDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.isBulkSelected);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.isSelected && !ctx_r1.isSelectionEnabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-file");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.isMultiSelect ? 11 : 12);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.riskProfile.description ? 13 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(16, 13, ctx_r1.riskProfile.user_modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind1(19, 16, ctx_r1.riskProfile));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.isMultiSelect ? 20 : -1);
} }
function RiskProfilesSelectSavedListItemComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RiskProfilesSelectSavedListItemComponent_Conditional_1_Conditional_0_Template, 21, 18, "div", 11);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r1.bulkActionSelectionService.idsByResourceType$) ? 0 : -1);
} }
/**
 * Risk Profiles Modal List Item Component
 *
 * A single row in a list of Risk Profiles.
 *
 */
export class RiskProfilesSelectSavedListItemComponent extends ContentItemBase {
    get riskProfile() {
        return this.folderable.item;
    }
    constructor(itemSelectionService) {
        super();
        this.itemSelectionService = itemSelectionService;
        this.isMultiSelect = false;
        this.hasShareableClientGroups = window.USER.shareableClientGroups.length > 0;
        this.FolderItemType = FolderableType;
    }
    get isSelectionEnabled() {
        return !this.maxItems || this.maxItems > this.itemSelectionService.numSelectedItems;
    }
    get isSelected() {
        return this.itemSelectionService.isSelected(this.riskProfile);
    }
    fileDropdownHandler() { }
}
RiskProfilesSelectSavedListItemComponent.ɵfac = function RiskProfilesSelectSavedListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskProfilesSelectSavedListItemComponent)(i0.ɵɵdirectiveInject(i1.ItemSelectionService)); };
RiskProfilesSelectSavedListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RiskProfilesSelectSavedListItemComponent, selectors: [["ycn-risk-profiles-select-saved-list-item"]], inputs: { folderable: "folderable", ancestorInfo: "ancestorInfo", isMultiSelect: "isMultiSelect", maxItems: "maxItems" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [["folderBase", ""], ["folderColumnDataFragment", ""], ["listItemFragment", ""], ["emptyFolderFragment", ""], [3, "folderable", "ancestorInfo", "folderColumnDataFragment", "listItemFragment", "emptyFolderFragment"], [1, "td", "col-3"], [1, "file-td-wrap", "pt-1", "pb-1", 3, "textContent"], [1, "td", "col-3", "col-md-2"], [1, "td", "file-td-grip", "col-3", "col-lg-1"], [3, "folderable", "ancestorInfo", "isMultiSelect", "maxItems"], [1, "get-started-small", "flex-auto"], ["ycn-folderable", "", 1, "tr", 3, "bg-yc-blue-90", "folderable", "ancestorInfo"], ["ycn-folderable", "", 1, "tr", 3, "folderable", "ancestorInfo"], [1, "td-checkbox"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", 3, "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], ["ycnDisabled", "", 1, "td", "file-td-name", 3, "click", "disabled"], [1, "file-name", "file-td-wrap", "pt-1", "pb-1"], ["draggable", "false", 1, "file-icon", "file-rp"], ["ycnIcon", "", 3, "name"], [1, "file-abbr"], ["draggable", "false", 1, "file-title", "cursor-pointer", 3, "textContent"], ["href", "javascript:void(0)", 3, "textContent"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent2", "ml-1", 3, "tooltipTitle", "tooltipHtml", "tooltipClasses", "tooltipPlacement"], ["ycnDisabled", "", 1, "td", "file-td-grip", "col-3", "col-lg-1", "cursor-pointer", 3, "disabled"], ["ycnDisabled", "", 1, "td", "file-td-grip", "col-3", "col-lg-1", "cursor-pointer", 3, "click", "disabled"], [1, "pt-1", "pb-1"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent"], ["ycnIcon", "", 1, "icon-remove-circle", "fill-current", "text-blue", 3, "name"], ["ycnIcon", "", 1, "icon-remove-circle", "fill-current", 3, "ngClass", "name"]], template: function RiskProfilesSelectSavedListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, RiskProfilesSelectSavedListItemComponent_Conditional_0_Template, 8, 5)(1, RiskProfilesSelectSavedListItemComponent_Conditional_1_Template, 2, 3);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.folderable.resourceType === "folder" ? 0 : 1);
    } }, dependencies: [i2.NgClass, i3.DisabledDirective, i4.IconDirective, i5.TooltipDirective, i6.FolderableDirective, i7.FolderBaseComponent, RiskProfilesSelectSavedListItemComponent, i2.AsyncPipe, i2.DatePipe, i8.GetOwnerDisplayName], encapsulation: 2 });
